/** Ein Wörterbuch für M2c-Servergründe (DESIGN.md: interne Codes deutsch, Code im title).
 * Unbekannte Codes bleiben roh sichtbar, damit nichts still verschwindet. */
const REASONS: Readonly<Record<string, string>> = {
  M2C_UNRESOLVED: 'Ungeklärte Aktion im Permit — zuerst klären.',
  M2C_PERMIT_STOPPED: 'Permit gestoppt.',
  M2C_PERMIT_EXPIRED: 'Permit außerhalb der Laufzeit.',
  M2C_KILL_SWITCH: 'Not-Aus aktiv.',
  M2C_SETTINGS_CHANGED: 'Familieneinstellungen geändert.',
  M2C_MEMBERSHIP: 'Kampagne nicht eindeutig der Familie zugeordnet.',
  M2C_STALE_ENTITIES: 'Entity-Sync veraltet.',
  M2C_STALE_METRICS: 'Metrik-Sync veraltet.',
  M2C_STALE_SEARCH_TERMS: 'Suchbegriff-Sync veraltet.',
  M2C_SYNC_RUNNING: 'Sync läuft gerade.',
  M2C_SYNC_NOT_CLEAN: 'Letzter Sync nicht sauber abgeschlossen.',
  M2C_SYNC_DRIFT: 'Sync-Stand seit der Vorschau geändert.',
  M2C_SCOPE: 'Außerhalb des Permit-Umfangs (nur Keywords der Permit-Kampagne).',
  M2C_EVIDENCE_MISSING: 'Keine gültige M2b-Empfehlung.',
  M2C_EVIDENCE_CHANGED: 'M2b-Empfehlung seit der Vorschau geändert.',
  M2C_LOCAL_BID_UNKNOWN: 'Aktuelles Gebot unbekannt.',
  M2C_BID_NOT_INTEGER_CENTS: 'Gebot nicht in ganzen Cent.',
  M2C_SOURCE_BID_OUT_OF_RANGE: 'Ausgangsgebot außerhalb des Pilotbereichs.',
  M2C_NO_DECREASE: 'Empfehlung liegt nicht unter dem aktuellen Gebot.',
  M2C_STEP_BELOW_ONE_CENT: 'Senkung kleiner als 1 Cent.',
  M2C_ACTION_INVALID: 'Aktion aus den Serverdaten nicht bildbar.',
}

export function m2cReasonText(code: string): string {
  return REASONS[code] ?? code
}
